__turbopack_context__.v({
  "band": "ClickRankings-module__PsLCJG__band",
  "bounds": "ClickRankings-module__PsLCJG__bounds",
  "column": "ClickRankings-module__PsLCJG__column",
  "columnHeading": "ClickRankings-module__PsLCJG__columnHeading",
  "earned": "ClickRankings-module__PsLCJG__earned",
  "entries": "ClickRankings-module__PsLCJG__entries",
  "laurel": "ClickRankings-module__PsLCJG__laurel",
  "measured": "ClickRankings-module__PsLCJG__measured",
  "pair": "ClickRankings-module__PsLCJG__pair",
  "section": "ClickRankings-module__PsLCJG__section",
  "skeleton": "ClickRankings-module__PsLCJG__skeleton",
});
